import { AlertDialog, AlertDialogDescription, AlertDialogCancel, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "../ui/alert-dialog";
import { format, parseISO } from "date-fns";

export default function DescricaoModal({ children, registro }) {

    return (
        <AlertDialog>
            <AlertDialogTrigger className="w-[14px]">
                {children}
            </AlertDialogTrigger>
            <AlertDialogContent>
                <AlertDialogHeader className="max-w-none">
                    <AlertDialogTitle>Registro {format(parseISO(registro.data), "dd/MM/yyyy")}</AlertDialogTitle>
                </AlertDialogHeader>
                <AlertDialogDescription
                    className="break-words"
                    style={{ maxHeight: "350px", overflowY: "auto", overflowX: "hidden" }}
                >
                    {registro.descricao}
                </AlertDialogDescription>
                <AlertDialogFooter>
                    <AlertDialogCancel>Fechar</AlertDialogCancel>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    )
}